import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function SkillGauge() {
  const sgauges = [
    { sgid: 1, name: "Photoshop", percent: '90%' },
    { sgid: 2, name: "Illustrator", percent: '75%' },
    { sgid: 3, name: "InDesign", percent: '65%' },
    { sgid: 4, name: "XD", percent: '50%' },
    { sgid: 5, name: "Dreamweaver", percent: '75%' },
    { sgid: 6, name: "Visual Studio", percent: '40%' }, 
    { sgid: 7, name: "Premiere Pro", percent: '85%' },
    { sgid: 8, name: "After Effects", percent: '60%' },
    { sgid: 9, name: "Animate", percent: '70%' },
    { sgid: 10, name: "Blender", percent: '60%' },
    { sgid: 11, name: "Dimension", percent: '45%' },
    { sgid: 12, name: "Soundbooth", percent: '60%' },
  ];

  const skill_gauge_ref = useRef();

  useGSAP(() => {
    // Scoped query within the component container
    const thumbs = gsap.utils.toArray('.skill_gauge'); 

    ScrollTrigger.batch(thumbs, {
      start: 'center center',
      once: true,
      onEnter: (batch) => {
        batch.forEach((section) => {
          const tl_sg = gsap.timeline();
          const gauge_needle = section.querySelector('.skill_gauge_needle');
          const gauge_bar = section.querySelectorAll('.skill_gauge_bar_bg path');
          const txtPercent = section.querySelector(".skill_gauge_txt");

          // Target percentage calculation
          const tPercentClean = parseFloat(txtPercent.textContent) || 0;
          const targetRotation = (tPercentClean / 100) * 180;

          // Counter object for smooth number incrementing
          const counter = { val: 0 };

          tl_sg
            .to(counter, {
              val: tPercentClean,
              duration: 1.5,
              ease: "power1.inOut",
              onUpdate: () => {
                txtPercent.textContent = `${Math.round(counter.val)}%`;
              }
            })
            .to(gauge_needle, {
              duration: 1,
              rotation: targetRotation,
              transformOrigin: "113px 20px",
              ease: "power2.out"
            }, 0.4)
            .to(gauge_bar, {
              duration: 1,
              rotation: targetRotation,
              transformOrigin: "150px 150px",
              ease: "power2.out"
            }, 0.45);
        });
      }
    });
  }, { scope: skill_gauge_ref });

  return (
    <div className="skill_gauge_container" ref={skill_gauge_ref}> 
      {sgauges.map((gauge) => (
        <div className="skill_gauge" key={gauge.sgid}>
          <svg className="skill_gauge_cont" version="1.1" x="0px" y="0px" viewBox="0 0 300 172">
            <text 
              x="50%" 
              y="70%" 
              className="skill_gauge_txt" 
              alignmentBaseline="middle" 
              textAnchor="middle"
            >
              {gauge.percent}
            </text>
            <defs>
              <clipPath id={`clipPath${gauge.sgid}`}>
                <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
              </clipPath>
            </defs>
            <g className="skill_gauge_indicator">
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
            </g>
            <g className="skill_gauge_bar_bg" style={{ clipPath: `url(#clipPath${gauge.sgid})` }}> 
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
            </g>
            <g className="skill_gauge_needle">
              <path d="M133.1,139.4l-96.4,10.7l96.4,10.4c3.5,5.7,9.8,9.5,17,9.5c11,0,20-9,19.9-20.1c0-11-9-20-20.1-19.9C142.9,129.9,136.6,133.7,133.1,139.4z"/>
            </g>
          </svg>
          <div className="gauge-title">{gauge.name}</div>
        </div>
      ))}
    </div>
  );
}